<template>
  <modal v-model:show="modal_show" modal-classes="modal-danger" modal-content-classes="bg-gradient-danger">
    <template v-slot:header>
      <h6 class="modal-title">{{ $t($route.name + '.deletePromptModalTitle') }}</h6>
    </template>

    <div class="py-3 text-center">
      <i class="bi bi-exclamation-triangle-fill fa-5x"></i>
      <h4 class="heading mt-4">{{ $t($route.name + '.deleteModalBody') }}</h4>
      <h5 v-if="selectedTerrain != null" class="heading mt-4">{{ selectedTerrain.name }}</h5>

      <span v-if="deleteError">{{ deleteError }}</span>

    </div>

    <template v-slot:footer>
      <div class="row">
        <div class="col">

          <base-button type="link" class="text-white ml-auto" v-on:click="onDeleteHandle(true)">{{ $t($route.name +
            '.deleteModalAccept') }}</base-button>
        </div>
        <div class="col">
          <base-button type="link" class="text-white ml-auto" v-on:click="onDeleteHandle(false)"><b>{{ $t($route.name +
            '.deleteModalRejec') }}</b></base-button>
        </div>
      </div>
    </template>
  </modal>
  <div class="card">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">{{ $t($route.name + '.terrainsTableTitle') }}</h3>
        </div>
        <div class="col text-right">
          <base-button type="success" icon="ni ni-fat-add" v-on:click="onModifyClick('')">{{ $t($route.name +
            '.terrainNewTerrainButton') }}
          </base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table thead-classes="thead-light" :data="terrainList">
        <template v-slot:columns>
          <th>{{ $t($route.name + '.terrainName') }}</th>
          <th>{{ $t($route.name + '.terrainPlotActionHeader') }}</th>
          <th>{{ $t($route.name + '.terrainAddressMunicipality') }}</th>
          <th>{{ $t($route.name + '.terrainHomogeneousGrowingArea') }}</th>
          <th>{{ $t($route.name + '.terrainCoordinates') }}</th>
        </template>

        <template v-slot:default="row">
          <th scope="row">
            {{ row.item.name }}
          </th>
          <td>
            <div class="row">
              <a type="button" style="padding: 2px;" v-on:click="onModifyClick(row.item)">
                <i class="bi bi-pencil-fill text-blue fa-2x"></i>
              </a>
              <a type="button" style="padding: 2px;" v-on:click="onDeleteClick(row.item)">
                <i class="bi bi-trash-fill text-red fa-2x"></i>
              </a>

            </div>
          </td>
          <td>
            {{ row.item.address.municipality }}
          </td>
          <td>
            {{ row.item.homogeneous_growing_area }}
          </td>
          <td>
            {{ row.item.coordinates }}
          </td>
        </template>
      </base-table>
    </div>
  </div>
</template>
<script>
import LandlordService from '@/services/landlord.service'
import TerrainService from '@/services/terrain.service'

export default {
  name: "terrains-table",
  created() {
    const user = JSON.parse(localStorage.getItem("user")).user;

    LandlordService.getLandlordAllDataById(user.id).then(
      landlord => {
        localStorage.setItem('landlord', JSON.stringify(landlord));

        landlord.terrains.forEach((terrain) => {
          if (terrain.name != "UnallocatedModulesTerrain") {
            this.terrainList.push(terrain)
          }
        });
      })

  },
  data() {
    return {
      terrainList: [],
      selectedTerrain: null,
      modal_show: false,
      deleteError: null,
      fetching: false,
    };
  },
  methods: {
    onModifyClick(terrain) {
      if(terrain.id !== undefined){
        localStorage.setItem("terrainId", terrain.id)
      }else{
        localStorage.setItem("terrainId", '')
      }
      this.$router.push({ name: 'terrain_manager' })
    },
    onDeleteClick(terrain) {
      this.selectedTerrain = terrain
      this.modal_show = true
    },
    onDeleteHandle(selection) {
      if (!selection) {
        this.modal_show = false;
        this.selectedTerrain = null;
        return;
      }
      if(this.fetching){
        return;
      }
      this.fetching = true;
      /* HANDLE DELETE TERRAIN */
      TerrainService.deleteTerrainById(this.selectedTerrain.id).then(
        () => {
          this.fetching = false;
          this.$router.go();

        },
        error => {
          this.deleteError = error
        }
      )

    }


  }
};
</script>
<style></style>
